var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 0.666016C4.39996 0.666016 0.666626 4.39935 0.666626 8.99935C0.666626 13.5993 4.39996 17.3327 8.99996 17.3327C13.6 17.3327 17.3333 13.5993 17.3333 8.99935C17.3333 4.39935 13.6 0.666016 8.99996 0.666016ZM8.99996 9.83268C8.54163 9.83268 8.16663 9.45768 8.16663 8.99935V5.66602C8.16663 5.20768 8.54163 4.83268 8.99996 4.83268C9.45829 4.83268 9.83329 5.20768 9.83329 5.66602V8.99935C9.83329 9.45768 9.45829 9.83268 8.99996 9.83268ZM8.16663 11.4993V13.166H9.83329V11.4993H8.16663Z",
    fill: "#D68916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftWarning);
export default __webpack_public_path__ + "static/media/soft-warning.6794682d734ed0535b7a5be0aacb31e2.svg";
export { ForwardRef as ReactComponent };